import React from 'react';
import { usePageMeta } from '../../hooks/usePageMeta';
import { PageHero } from '../../components/ui/PageHero';
import { Section } from '../../components/ui/Section';
import { ActionLink } from '../../components/ui/ActionLink';
import { TextLink } from '../../components/ui/TextLink';
import { BenefitList } from '../../components/ui/BenefitList';
import { StatusBadge } from '../../components/ui/StatusBadge';
import { EnquirySection } from '../../components/forms/EnquirySection';
import type { Benefit } from '../../types/content';
const plannedAreas: Benefit[] = [{
  title: 'Language for everyone',
  text: 'Free English sessions for people who cannot pay for a course.'
}, {
  title: 'Volunteer days',
  text: 'Students and staff help local groups with simple, practical projects.'
}, {
  title: 'Learning materials',
  text: 'Used books and materials go to schools and libraries that need them.'
}];
const takePart: Benefit[] = [{
  title: 'As a student',
  text: 'Join a volunteer day and practise English while you help others.'
}, {
  title: 'As a teacher',
  text: 'Give a free lesson to a community group.'
}, {
  title: 'As a partner group',
  text: 'Tell us about a local need that our team can help with.'
}];
export function ESHelps() {
  usePageMeta('ES Helps | Our Community Programme Is Coming Soon | ES World', 'ES Helps is our coming community programme. See what we plan and ask to receive news when it starts.');
  return <>
      <PageHero breadcrumbs={[{
      label: 'About Us',
      to: '/about/who-we-are'
    }, {
      label: 'ES Helps',
      to: '/about/es-helps'
    }]} badge={<StatusBadge data-id="element-954" data-mp="cp2d2v21ryzs">Coming soon</StatusBadge>} title="ES Helps: our community programme is coming soon" lead="ES Helps is the community programme of ES World. It will bring free English sessions, volunteer days and learning materials to people near our campuses. The programme is not active yet. Leave your details, and we will tell you when it starts." primary={{
      label: 'Ask for ES Helps news',
      to: '#enquire'
    }} secondary={{
      label: 'Read about ES World',
      to: '/about/who-we-are'
    }} data-id="element-953" data-mp="mlng5auib00z" />

      <Section id="plans" title="Help for the people around us" description="These are the areas we plan to work on first. Details may change before the programme starts." mockup="Planned activities" data-id="element-955" data-mp="2edai7sjfnddu">
        <BenefitList items={plannedAreas} columns={3} data-id="element-956" data-mp="1zma6nene33dh" />
        <div className="mt-10" data-id="element-957" data-mp="1zjnsgw5ztpma">
          <ActionLink to="/about/media" data-id="element-958" data-mp="1umnw5cyy418d">See our student community</ActionLink>
        </div>
      </Section>

      <Section id="join" bg="cream" title="Ways you can take part" description="Everyone at ES World will be able to join. Choose the way that suits you." aside={<TextLink to="/blog" data-id="element-960" data-mp="3kzmttbh0q23u">Read the ES Blog</TextLink>} data-id="element-959" data-mp="1qkk9ds6tta7s">
        <BenefitList items={takePart} columns={3} data-id="element-961" data-mp="3g0a6kpm8it0q" />
      </Section>

      <EnquirySection bg="grey" title="Be the first to hear" description="Leave your email, and we will tell you when ES Helps starts and how you can take part." submitLabel="Send my ES Helps request" showCourseFields={false} messageLabel="How would you like to help? (optional)" data-id="element-962" data-mp="3g0tgpk5n8d47" />
    </>;
}